import { useLocationStore as useLegacyLocationStore } from '@global-store/stores/location'
import { useLocationStore } from '@shared/global-store/stores/location/location'

export const bootstrapLocationSSR = async (location: URL) => {
  const locationStore = useLocationStore()
  const legacyLocationStore = useLegacyLocationStore()

  locationStore.setLocation(location)
  legacyLocationStore.setLocation(location)
}

export const bootstrapLocationClient = async () => {
  const locationStore = useLocationStore()
  const legacyLocationStore = useLegacyLocationStore()

  locationStore.setLocation(new URL(globalThis.location.href))
  legacyLocationStore.setLocation(new URL(globalThis.location.href))

  document.addEventListener('astro:after-swap', () => {
    locationStore.setLocation(new URL(globalThis.location.href))
    legacyLocationStore.setLocation(new URL(globalThis.location.href))
  })
}
